export var AdType;
(function (AdType) {
    AdType["PREROLL"] = "PREROLL";
    AdType["MIDROLL"] = "MIDROLL";
    AdType["POSTROLL"] = "POSTROLL";
    AdType["START"] = "START";
    AdType["FAST_FORWARD"] = "FAST_FORWARD";
    AdType["PAUSE"] = "PAUSE";
    AdType["UNKNOWN"] = "UNKNOWN";
})(AdType || (AdType = {}));
